import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=676f0552&scoped=true"
import script from "./Description.vue?vue&type=script&lang=ts"
export * from "./Description.vue?vue&type=script&lang=ts"
import style0 from "./Description.vue?vue&type=style&index=0&id=676f0552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f0552",
  null
  
)

export default component.exports